module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_j_leucistic.926ed8e0.png";